import { apiFetch } from "./fetchApi";

export const fetchUserHistoryApi = (BeURL, setLogHistory, currentPage, rowsPerPage, setTotlaSessionLogs, setTotalPage, id) => {
    apiFetch(`${BeURL}/fetch-Logs-History/${id}`, {
        method: 'POST',
        body: JSON.stringify({ pages: currentPage, sessionLogsPerPage: rowsPerPage })
    })
        .then(res => res.json())
        .then(data => {
            if (data.success === true) {
                setLogHistory(data?.logHistory);
                // navigate(`/fetch-log-history`);
                setTotlaSessionLogs(data.totalLogs)
                setTotalPage(data.totalPages)
            } else {
                console.log("Failed to fetch log history");
            }
        })
        .catch(err => {
            console.error('Error fetching session logs:', err);
        });
};